<mat-form-field class="chip-autocomplete" appearance="outline">
  <mat-label>Filename Format</mat-label>
  <mat-chip-grid
    #chipGrid
    aria-label="chip selection"
    cdkDropList
    cdkDropListOrientation="mixed"
    (cdkDropListDropped)="drop($event)">
    @for (chip of formCtrl.value ?? []; track chip) {
      <mat-chip-row cdkDrag (removed)="remove(chip)" (click)="selectedChip(chip)">
        {{chip.label}}
        <button matChipRemove [attr.aria-label]="'remove ' + chip.label">
          <mat-icon>cancel</mat-icon>
        </button>
      </mat-chip-row>
    }
  </mat-chip-grid>
  <input [placeholder]="(formCtrl?.value?.length ?? 0) === 0 ?'Please choose at least 1 token' : ''" #chipInput
    [formControl]="chipCtrl" [matChipInputFor]="chipGrid" [matAutocomplete]="auto"
    [matChipInputSeparatorKeyCodes]="separatorKeysCodes" (matChipInputTokenEnd)="add($event)" />
  <mat-autocomplete #auto="matAutocomplete" (optionSelected)="selected($event)">
    @for (chip of allChips; track chip) {
      <mat-option [value]="chip">
        {{chip.label}}
      </mat-option>
    }
  </mat-autocomplete>
</mat-form-field>
@if ((formCtrl.value?.length ?? 0) > 1) {
  <small class="chip-autocomplete-hint">Drag to reorder tokens</small>
}
@if (chipCtrl?.hasError('pattern')) {
  <mat-error style="margin: -15px 0 8px 5px;">Token must
  be [A-Z, 0-9, -, _]</mat-error>
}
